/**
 * Object of all mail protocoles
 */
const MAIL_PROTOCOLES = {
  TLS_PROTOCOLE: "TLS_PROTOCOLE",
  TLS_START_PROTOCOLE: "TLS_START_PROTOCOLE",
  SITE_PROTOCOLE: "SITE_PROTOCOLE"
}
export default MAIL_PROTOCOLES
